import { Component, ViewEncapsulation } from '@angular/core';
import { MaintenanceModeService } from './maintenance-mode.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'rdo-maintenance-window',
  templateUrl: './maintenance-mode.component.html',
  styleUrls: ['./maintenance-mode.component.scss'],
  standalone: false,
})
export class MaintenanceModeComponent {
  constructor(
    public service: MaintenanceModeService,
    public translateService: TranslateService
  ) {}
}
